import { render, staticRenderFns } from "./fingerpost.vue?vue&type=template&id=1cb3ef96&scoped=true&"
import script from "./fingerpost.vue?vue&type=script&lang=js&"
export * from "./fingerpost.vue?vue&type=script&lang=js&"
import style0 from "./fingerpost.vue?vue&type=style&index=0&id=1cb3ef96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3ef96",
  null
  
)

export default component.exports